<ng-http-loader
    [backdrop]="true"
    [backdropBackgroundColor]="'var(--alpha-overlay-background-color)'"
    [debounceDelay]="100"
    opacity="1"
    [entryComponent]="loaderComponent"
></ng-http-loader>
<router-outlet></router-outlet>
<p-toast position="bottom-center" [life]="2000" [baseZIndex]="getZindex()">
    <ng-template let-message pTemplate="message">
        <div class="flex w-full gap-3 align-items-center">
            <img [src]="statusIcons[message?.severity].src" width="32" height="32" alt="status icon" />
            <div class="flex flex-column">
                <span class="text-lg text-bold text-gray-50">{{ message?.summary }}</span>
                <span class="text-xsmall text-gray-50">{{ message?.detail }}</span>
            </div>
        </div>
    </ng-template>
</p-toast>

<p-confirmDialog #cd styleClass="w-30rem h-13rem">
    <ng-template pTemplate="icon"></ng-template>
    <ng-template pTemplate="footer">
        <div class="flex w-full gap-2 justify-content-end">
            <div class="flex-1">
                <p-button
                    label="{{ 'default-cm-no' | translate: 'No' }}"
                    (onClick)="cd.reject()"
                    [outlined]="true"
                    styleClass="w-full"
                ></p-button>
            </div>
            <div class="flex-1">
                <p-button
                    label="{{ 'default-cm-yes' | translate: 'Yes' }}"
                    (onClick)="cd.accept()"
                    styleClass="w-full"
                ></p-button>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>
